<template>
  <div
    class="freesearch-container"
    ref="container"
    @click.self="toggleShowFreeSearchList"
  >
    <freeSearchBarInputContainer :mefo="mefo" :searchId="searchId" />

    <freeSearchBarHeader :width="barWidth" :searchId="searchId" />
  </div>
</template>

<script>
import freeSearchBarHeader from "./freeSearchBarHeader.vue";
import freeSearchBarInputContainer from "./freeSearchBarInputContainer.vue";
import { createFreeSearchBookListStore } from "@/store_pinia";
const MIN_SIDE_WIDTH = 435;
export default {
  data() {
    return { barWidth: "wide" };
  },
  props: {
    mefo: { default: false },
    searchId: { default: "main" },
  },
  components: {
    freeSearchBarInputContainer,
    freeSearchBarHeader,
  },
  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    splitterChange() {
      return this.$store.state["tabsManager"].splitterChange;
    },
  },
  methods: {
    toggleShowFreeSearchList() {
      this.freeSearchBookListStore.toggleShowFreeSearchList();
    },
  },
  watch: {
    splitterChange: function () {
      if (this.$refs.container.clientWidth < MIN_SIDE_WIDTH)
        this.barWidth = "narrow";
      else this.barWidth = "wide";
    },
  },
};
</script>

<style lang="scss">
.freesearch-container {
  // background-color: var(--custom-color1);
  // background-image: linear-gradient(to right, var(--custom-color1), #81592a);
  // background-image: linear-gradient(to right, #c78c48, #81592a);
  height: 76px;
  position: relative;
  direction: ltr;
  .div-input {
    padding-right: 10px;
    padding-top: 0;
    margin-top: 15px;
    padding: 0;
    margin: 0;
  }

  input {
    border: 0 !important;
    outline: 0;
    padding-left: 70px;
  }
}
</style>
